var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTiktokIcon = function SvgTiktokIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.913 7.871H17.05v11.076c0 1.32-1.102 2.404-2.473 2.404-1.371 0-2.473-1.084-2.473-2.404 0-1.296 1.078-2.356 2.4-2.403v-2.781c-2.914.047-5.264 2.333-5.264 5.184 0 2.875 2.4 5.185 5.362 5.185s5.361-2.333 5.361-5.185v-5.68a6.831 6.831 0 0 0 3.795 1.226v-2.78c-2.154-.071-3.844-1.768-3.844-3.842Z",
    fill: "#424242"
  })));
};

export default SvgTiktokIcon;